module.exports = __webpack_public_path__ + "static/media/Back to 95 - ft Lance Conrad.ce68bd31.jpg";